import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GlobalStore, GlobalStoreProvider } from "./state/GlobalStore";

const globalStore = new GlobalStore();

ReactDOM.render(
  <React.StrictMode>
    <GlobalStoreProvider value={globalStore}>
      <App />
    </GlobalStoreProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
